import classnames from 'owa-classnames';

import {
    gradient,
    darkGradient,
    lightGradient,
    neutralBackground,
    blurred,
} from './BlurredBackgroundView.scss';

export interface BlurredBackgroundViewProps {
    className?: string;
    isDarkTheme?: boolean;
    isNeutralTheme?: boolean;
    isBlurred?: boolean;
    gradientClassName?: string;
}

export default function BlurredBackgroundView({
    className,
    isDarkTheme = false,
    isNeutralTheme = false,
    isBlurred = true,
    gradientClassName,
}: BlurredBackgroundViewProps): JSX.Element {
    return (
        <div className={className}>
            <div
                className={classnames(
                    gradientClassName ? gradientClassName : className,
                    gradient,
                    isNeutralTheme ? neutralBackground : isDarkTheme ? darkGradient : lightGradient,
                    isBlurred && blurred
                )}
            />
        </div>
    );
}
